import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import type React from "react";
import {
  tooltipArrowClass,
  tooltipPopupClass,
  tooltipPositionerClass,
} from "./styles.css";

export type TooltipSide = "top" | "bottom" | "left" | "right";
export type TooltipAlign = "start" | "center" | "end";

interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactElement;
  side?: TooltipSide;
  align?: TooltipAlign;
  sideOffset?: number;
  delay?: number;
  disabled?: boolean;
}

export const Tooltip = ({
  content,
  children,
  side = "top",
  align = "center",
  sideOffset = 4,
  delay = 0,
  disabled = false,
}: TooltipProps) => {
  return (
    <BaseTooltip.Provider>
      <BaseTooltip.Root disabled={disabled}>
        <BaseTooltip.Trigger render={children} delay={delay} />
        <BaseTooltip.Portal>
          <BaseTooltip.Positioner
            side={side}
            align={align}
            sideOffset={sideOffset}
            className={tooltipPositionerClass}
            data-slot="tooltip-positioner"
          >
            <BaseTooltip.Popup
              className={tooltipPopupClass}
              data-slot="tooltip-popup"
            >
              {content}
              <BaseTooltip.Arrow
                className={tooltipArrowClass}
                data-slot="tooltip-arrow"
              />
            </BaseTooltip.Popup>
          </BaseTooltip.Positioner>
        </BaseTooltip.Portal>
      </BaseTooltip.Root>
    </BaseTooltip.Provider>
  );
};

Tooltip.displayName = "Tooltip";
